import { baseApi } from './baseApi';

export interface HealthConfig {
  ssh_tunnel_host: string;
  ssh_tunnel_port: number;
}

export const systemApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get runtime health/config (e.g. SSH tunnel connection details)
    getHealthConfig: builder.query<HealthConfig, void>({
      query: () => '/health/config',
      providesTags: [{ type: 'System', id: 'CONFIG' }],
    }),
  }),
});

export const { useGetHealthConfigQuery } = systemApi;
